import PropTypes from "prop-types";
import React, { Component } from "react";
import { color } from "backpack-ui/settings.json";
import Portal from "react-portal";
import uniq from "lodash/uniqBy";
import ImageCarousel from "../imageCarousel";
import ImageGallery from "../imageGallery";
import ImageHero from "../imageHero";

const _ = { uniq };

const style = {
  attribution: {
    color: color.lightText,
    fontSize: "11px",
    letterSpacing: ".1px",
    display: "block",
    position: "relative",
    top: "4px",
  },
};

const propTypes = {
  /**
   * Array of images
   */
  images: PropTypes.array.isRequired,

  /**
   * Array of width, height
   */
  carouselSize: PropTypes.array.isRequired,

  /**
   * Whether or not the layout is mobile
   */
  mobile: PropTypes.bool,

  attribution: PropTypes.arrayOf(PropTypes.object),
};

const defaultProps = {
  images: [],

  carouselSize: [770, 430],

  mobile: false,
};

class ImagesContainer extends Component {
  static parseImages(images) {
    const carouselImages = [];
    const galleryImages = [];

    const gallerySizes = {
      viator: [674, 446],
      gadventures: [770, 385],
      bdc: [500, 333],
      hostelworld: [800, 422],
      media: [1024, 768],
    };

    _.uniq(images).forEach(image => {
      // remove all protocols from images
      const source = typeof image === "object"
        ? image.src.replace(/^.*?:/, "")
        : image.replace(/^.*?:/, "");
      const provider = image.provider ? image.provider : "";

      carouselImages.push(source);

      galleryImages.push({
        src: source,
        thumbnail: source,
        w: gallerySizes[provider] ? gallerySizes[provider][0] : "",
        h: gallerySizes[provider] ? gallerySizes[provider][1] : "",
        title: "",
      });
    });

    return { carouselImages, galleryImages };
  }

  constructor(props) {
    super(props);

    this.state = {
      index: 0,
      isOpen: false,
    };

    [
      "toggleGallery",
      "afterChange",
      "returnImageHero",
      "returnImageGallery",
      "returnImageCarousel",
    ].forEach(fn => {
      this[fn] = this[fn].bind(this);
    });
  }

  toggleGallery() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  afterChange(newIndex) {
    this.setState({
      index: newIndex,
    });
  }

  returnImageHero(images) {
    return <ImageHero image={images[0]} imageSize={this.props.carouselSize} />;
  }

  returnImageGallery() {
    return (
      <Portal
        className="ImageGallery-portal"
        key="ImageGallery"
        style={{ height: 0, width: 0 }}
        isOpened
      >
        <ImageGallery
          isOpen={this.state.isOpen}
          images={ImagesContainer.parseImages(this.props.images).galleryImages}
          options={{
            index: this.state.index,
            history: false,
            counterEl: false,
          }}
          onClose={this.toggleGallery}
        />
      </Portal>
    );
  }

  returnImageCarousel(images) {
    const { carouselSize, mobile } = this.props;

    return (
      <div
        className="ImageCarousel-container"
        style={mobile ? { overflow: "hidden" } : {}}
      >
        <ImageCarousel
          images={images}
          index={this.state.index}
          onExpand={!mobile ? this.toggleGallery : null}
          afterChange={this.afterChange}
          imageSize={carouselSize}
          hideNavigation={mobile}
          lazyLoad
        />

        {!mobile && this.returnImageGallery()}
      </div>
    );
  }

  render() {
    const { attribution } = this.props;
    const parsedImages = ImagesContainer.parseImages(this.props.images)
      .carouselImages;

    const component = parsedImages.length > 1
      ? this.returnImageCarousel(parsedImages)
      : this.returnImageHero(parsedImages);

    return (
      <div className="ImagesContainer">
        {component}
        {attribution &&
          attribution.length > 0 &&
          attribution.map(a => (
            <small
              key={`${a.name} ${a.organization}`}
              style={style.attribution}
            >
              {a.name} {a.organization}
            </small>
          ))}
      </div>
    );
  }
}

ImagesContainer.propTypes = propTypes;
ImagesContainer.defaultProps = defaultProps;

export default ImagesContainer;


// WEBPACK FOOTER //
// ./assets/pois/components/imagesContainer/index.jsx